import { DeleteOutlined } from '@ant-design/icons';
import { Col, Divider, Input, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useCallback, useState, Fragment } from 'react';

import { Controller, useFieldArray } from 'react-hook-form';
import withStyles from 'react-jss';
import { useSelector } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';
import AccessoryForm from './AccessoryForm';
import FabricForm from './FabricForm';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);

const { Option } = Select;

const StyleForm = props => {
  const {
    productIndex,
    styleItem,
    styleIndex,
    stylesRemove,
    classes,
    getValues,
    setValue,
    control,
    FabricsForSample,
    AccessoriesForSample,
    watch,
  } = props;

  const stylesForSample = useSelector(state => state.stylesForJobchart);
  const colorIds = useSelector(state => state.colorIds);

  const [descriptions, setDescriptions] = useState({
    descriptionIndexes: {},
    descriptions: [],
  });

  const {
    fields: fabricFields,
    append: fabricsAppend,
    remove: fabricsRemove,
  } = useFieldArray({
    control,
    name: `products[${productIndex}].styles[${styleIndex}].fabrics`,
  });

  const {
    fields: accessoryFields,
    append: accessoriesAppend,
    remove: accessoriesRemove,
  } = useFieldArray({
    control,
    name: `products[${productIndex}].styles[${styleIndex}].accessories`,
  });

  const changeTotalQuantity = useCallback(styleTotalQuantity => {
    setValue(
      `products[${productIndex}].styles[${styleIndex}].totalQuantity`,
      styleTotalQuantity
    );

    const fabrics = getValues(
      `products[${productIndex}].styles[${styleIndex}].fabrics`
    );
    const accessories = getValues(
      `products[${productIndex}].styles[${styleIndex}].accessories`
    );

    if (fabrics && fabrics.length) {
      fabrics.map(({ consumption, additionalPercentage, stock }, index) => {
        if (+consumption) {
          const quantity = +consumption * styleTotalQuantity;

          const totalQuantity = (
            (+quantity || 0) *
            (1 + (+additionalPercentage || 0) / 100)
          ).toFixed(2);

          setValue(
            `products[${productIndex}].styles[${styleIndex}].fabrics[${index}].quantity`,
            quantity
          );
          setValue(
            `products[${productIndex}].styles[${styleIndex}].fabrics[${index}].totalQuantity`,
            totalQuantity
          );

          if (+stock >= +totalQuantity) {
            setValue(
              `products[${productIndex}].styles[${styleIndex}].fabrics[${index}].toOrder`,
              0
            );
          } else {
            setValue(
              `products[${productIndex}].styles[${styleIndex}].fabrics[${index}].toOrder`,
              +(+totalQuantity - +stock).toFixed(2)
            );
          }
        }
      });
    }

    if (accessories && accessories.length) {
      accessories.map(({ consumption, additionalPercentage, stock }, index) => {
        if (+consumption) {
          const quantity = +consumption * styleTotalQuantity;

          const totalQuantity = (
            (+quantity || 0) *
            (1 + (+additionalPercentage || 0) / 100)
          ).toFixed(2);

          setValue(
            `products[${productIndex}].styles[${styleIndex}].accessories[${index}].quantity`,
            quantity
          );
          setValue(
            `products[${productIndex}].styles[${styleIndex}].accessories[${index}].totalQuantity`,
            totalQuantity
          );

          if (+stock >= +totalQuantity) {
            setValue(
              `products[${productIndex}].styles[${styleIndex}].accessories[${index}].toOrder`,
              0
            );
          } else {
            setValue(
              `products[${productIndex}].styles[${styleIndex}].accessories[${index}].toOrder`,
              +(+totalQuantity - +stock).toFixed(2)
            );
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    const name = getValues(
      `products[${productIndex}].styles[${styleIndex}].name`
    );

    if (stylesForSample.styleIndexes[name] !== undefined) {
      const _descriptions = stylesForSample.descriptions[name];

      setDescriptions(_descriptions);

      const styleId = getValues(
        `products[${productIndex}].styles[${styleIndex}].styleId`
      );

      if (styleId) {
        const descriptionIndex = _descriptions.descriptionIndexes[styleId];

        if (descriptionIndex === undefined) {
          setValue(
            `products[${productIndex}].styles[${styleIndex}].styleId`,
            null
          );
          setValue(
            `products[${productIndex}].styles[${styleIndex}].size`,
            null
          );
        }
      }
    }
  }, [
    stylesForSample,
    watch(`products[${productIndex}].styles[${styleIndex}].name`),
  ]);

  return (
    <>
      <Divider orientation="left" plain>
        Style {styleIndex + 1} &nbsp;&nbsp;
        <DeleteOutlined
          size="large"
          onClick={() => {
            const _styles = getValues(`products[${productIndex}].styles`);

            if (_styles && _styles.length > 1) {
              stylesRemove(styleIndex);
            }
          }}
        />
      </Divider>
      <Row>
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].name`}
            control={control}
            defaultValue={styleItem.name}
            render={({ field }) => (
              <AntSelect
                allowClear
                label="Style"
                placeholder="Select Style"
                {...field}
              >
                {stylesForSample.styleNames.map(name => (
                  <Option key={name} value={name}>
                    {name}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].styleId`}
            control={control}
            defaultValue={styleItem.styleId}
            render={({ field }) => (
              <AntSelect
                allowClear
                label="Description"
                placeholder="Select Description"
                {...field}
                onChange={id => {
                  field.onChange(id);

                  if (descriptions.descriptionIndexes[id] !== undefined) {
                    setValue(
                      `products[${productIndex}].styles[${styleIndex}].size`,
                      descriptions.descriptions[
                        descriptions.descriptionIndexes[id]
                      ].size
                    );
                  }
                }}
              >
                {descriptions.descriptions.map((description, index) => (
                  <Option key={index} value={description.id}>
                    {description.description}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].size`}
            control={control}
            defaultValue={styleItem.size}
            render={({ field }) => (
              <AntInput
                allowClear
                label="Size"
                placeholder="Size"
                disabled
                {...field}
              />
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].baseColorId`}
            control={control}
            defaultValue={styleItem.baseColorId}
            render={({ field }) => (
              <AntSelect
                allowClear
                label="Base Color"
                placeholder="Select Color"
                {...field}
              >
                {colorIds.map((color, index) => (
                  <Option key={index} value={color.id}>
                    {color.color}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].printColorId`}
            control={control}
            defaultValue={styleItem.printColorId}
            render={({ field }) => (
              <AntSelect
                allowClear
                label="Print Color"
                placeholder="Select Color"
                {...field}
              >
                {colorIds.map((color, index) => (
                  <Option key={index} value={color.id}>
                    {color.color}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].embroideryColorId`}
            control={control}
            defaultValue={styleItem.embroideryColorId}
            render={({ field }) => (
              <AntSelect
                allowClear
                label="Embroidery Color"
                placeholder="Select Color"
                {...field}
              >
                {colorIds.map((color, index) => (
                  <Option key={index} value={color.id}>
                    {color.color}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].acidWashColorId`}
            control={control}
            defaultValue={styleItem.acidWashColorId}
            render={({ field }) => (
              <AntSelect
                allowClear
                label="Acid Wash Color"
                placeholder="Select Color"
                {...field}
              >
                {colorIds.map((color, index) => (
                  <Option key={index} value={color.id}>
                    {color.color}
                  </Option>
                ))}
              </AntSelect>
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].quantity`}
            control={control}
            defaultValue={styleItem.quantity}
            render={({ field }) => (
              <AntInput
                allowClear={false}
                label="Quantity"
                placeholder="Quantity"
                {...field}
                type="number"
                onChange={e => {
                  field.onChange(e);
                  const quantity = e.target.value;

                  const additional = getValues(
                    `products[${productIndex}].styles[${styleIndex}].additional`
                  );

                  changeTotalQuantity((+quantity || 0) + (+additional || 0));
                }}
              />
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].additional`}
            control={control}
            defaultValue={styleItem.additional}
            render={({ field }) => (
              <AntInput
                allowClear={false}
                label="Additional"
                placeholder="Additional"
                type="number"
                {...field}
                onChange={e => {
                  field.onChange(e);
                  const additional = e.target.value;

                  const quantity = getValues(
                    `products[${productIndex}].styles[${styleIndex}].quantity`
                  );

                  changeTotalQuantity((+quantity || 0) + (+additional || 0));
                }}
              />
            )}
          />
        </Col>
        &nbsp; &nbsp;
        <Col xs={3}>
          <Controller
            name={`products[${productIndex}].styles[${styleIndex}].totalQuantity`}
            control={control}
            defaultValue={styleItem.totalQuantity}
            render={({ field }) => (
              <AntInput
                label="Total Quantity"
                placeholder="Total Quantity"
                type="number"
                disabled
                {...field}
              />
            )}
          />
        </Col>
      </Row>
      <Row>
        <table className={classes.inputTable}>
          <thead className={classes.inputThead}>
            <tr>
              <th className={classes.inputTh}>Fabric</th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Width
              </th>
              <th className={classes.inputTh} style={{ width: '10%' }}>
                Base Color
              </th>
              <th className={classes.inputTh} style={{ width: '10%' }}>
                Print Color
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Consumption
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Net Qty
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Shrinkage(%)
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Total
              </th>
              <th className={classes.inputTh} style={{ width: '7%' }}>
                Stock
              </th>
              <th className={classes.inputTh} style={{ width: '7%' }}>
                To Order
              </th>
              <th className={classes.inputTh} style={{ width: '6%' }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {fabricFields.map((item, index) => (
              <FabricForm
                key={item.id}
                fabricItem={item}
                fabricIndex={index}
                fabricsAppend={fabricsAppend}
                fabricsRemove={fabricsRemove}
                FabricsForSample={FabricsForSample}
                productIndex={productIndex}
                styleIndex={styleIndex}
                getValues={getValues}
                setValue={setValue}
                control={control}
                watch={watch}
              />
            ))}
          </tbody>
        </table>
      </Row>
      <br />
      <Row>
        <table className={classes.inputTable}>
          <thead className={classes.inputThead}>
            <tr>
              <th className={classes.inputTh}>Accessory</th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Consumption
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Net Qty
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Shrinkage(%)
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Total
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                Stock
              </th>
              <th className={classes.inputTh} style={{ width: '8%' }}>
                To Order
              </th>
              <th className={classes.inputTh} style={{ width: '6%' }}>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {accessoryFields.map((item, index) => (
              <AccessoryForm
                key={item.id}
                accessoryItem={item}
                accessoryIndex={index}
                accessoriesAppend={accessoriesAppend}
                accessoriesRemove={accessoriesRemove}
                AccessoriesForSample={AccessoriesForSample}
                productIndex={productIndex}
                styleIndex={styleIndex}
                getValues={getValues}
                setValue={setValue}
                control={control}
                watch={watch}
              />
            ))}
          </tbody>
        </table>
      </Row>
    </>
  );
};

StyleForm.propTypes = {
  classes: PropTypes.object.isRequired,
  styleItem: PropTypes.object.isRequired,
  styleIndex: PropTypes.number.isRequired,
  productIndex: PropTypes.number.isRequired,
  stylesRemove: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  FabricsForSample: PropTypes.object,
  AccessoriesForSample: PropTypes.array,
};

export default withStyles(styles)(StyleForm);
